import type { RpcMethodParameters } from '@scayle/storefront-nuxt'
import type { RpcOptions } from '../types/rpc'

type Options = Partial<{
  params: MaybeRefOrGetter<RpcMethodParameters<'getCategoryAlternateNames'>>
  options: RpcOptions
  key: string
}>

export default ({
  key = 'useCategoryAlternateNames',
  params,
  options,
}: Options) => {
  const { data, refresh, status } = useRpc(
    'getCategoryAlternateNames',
    key,
    params,
    options,
  )

  return { data, refresh, status }
}
